// extracted by mini-css-extract-plugin
export default {"noProductsMessageContainer":"style--noProductsMessageContainer--ce15fd"};